export const Modal = ({ size = 'small', isOpen = false, children }) => {
  if (!isOpen) return null
  return <div>
    <div className='control-modal-overlay' />
    <section role='dialog' class={`control-modal control-modal-${size}`} >
      {children}
    </section>
  </div>
}
